export const FETCH_FUNNELS_REQUEST = 'FETCH_FUNNELS_REQUEST';
export const FETCH_FUNNELS_SUCCESS = 'FETCH_FUNNELS_SUCCESS';
export const FETCH_FUNNELS_FAILURE = 'FETCH_FUNNELS_FAILURE';

export const fetchFunnelsRequest = () => ({
  type: FETCH_FUNNELS_REQUEST
});

export const fetchFunnelsSuccess = (funnels) => ({
  type: FETCH_FUNNELS_SUCCESS,
  payload: funnels
});

export const fetchFunnelsFailure = (error) => ({
  type: FETCH_FUNNELS_FAILURE,
  payload: error
});
